export default "__VITE_ASSET__Cz0erx00__"